<template>
    <div ref="advSearchDom">
        <div class="type-selector-box ">
            <TypeSelector
                :currType="currType"
                :parentType="parentType"
                :mainTypeList="mainTypeList"
                :subTypeList="subTypeList"
                @selectOption="selectOptionCallback"
            />
        </div>

        <el-row
            :gutter="10"
            class="adv-part-box"
            v-show="advList.length > 0"
        >
            <el-col
                :span="cols"
                v-for="(v, i) in advList"
                :key="v.id"
                style="margin-bottom: 10px"
            >
                <div class="adv-record-box">
                    <div class="title-box">
                        <span>{{getTitle(v)}}</span>
                    </div>

                    <AdvIframe
                        :width="advWidth"
                        :height="advHeight"
                        :videoUrl="v.addinfo2"
                        v-if="myUtil.isNotEmpty(v.addinfo2) && myUtil.isEmpty(v.addinfo3) && v.jatype != 2"
                    />

                    <AdvVideo
                        :width="advWidth"
                        :height="advHeight"
                        :videoUrl="v.addinfo3"
                        v-if="myUtil.isNotEmpty(v.addinfo3) && v.jatype != 2"
                    />

                    <AdvCustomerCase
                        :width="advWidth"
                        :height="advHeight"
                        :obj="v"
                        v-if="v.jatype == 2"
                    />
                </div>

            </el-col>
        </el-row>

        <el-empty v-show="advList.length == 0" :description="i18n.tkey('lang_temporary_no_data')" />
    </div>
</template>

<script setup>

import myUtil from "@/util/util";
import AdvVideo from "@/components/shopopee/promotion/advVideo.vue";
import AdvIframe from "@/components/shopopee/promotion/advIframe.vue";
import TypeSelector from "@/components/Shopopee3D/ui/typeSelector.vue";
import AdvCustomerCase from "@/components/shopopee/promotion/advCustomerCase.vue";
import {getCurrentInstance, inject, ref, toRef, onBeforeMount, onMounted} from "vue";
import jobArrangementRecordApi from "@/request/jobArrangementRecordApi";
import {useUserinfo} from "@/stores/userinfo";

const i18n = inject("i18n")
const { proxy } = getCurrentInstance();
const userInfoRef = toRef(useUserinfo())

const domWidth = ref(340)
const cols = ref(12)
const advList = ref([])
const advTypeList = ref([])
const advWidth = ref(320)
const advHeight = ref(180)

const currType = ref(0)
const parentType = ref(0)
const mainTypeList = ref([])
const subTypeList = ref([])

const customerRecordList = ref([])

let advTypeMap = {}
let allAdvList = []

function getCompanyname(obj){
    let name = obj.companyname2

    if (myUtil.isEmpty(name) || userInfoRef.value.lang === "zh" || userInfoRef.value.lang === "szh"){
        name = obj.companyname
    }

    return name
}

function getTitle(obj){
    let name = obj.shipmentaddresscn

    if (myUtil.isEmpty(name) || userInfoRef.value.lang === "zh" || userInfoRef.value.lang === "szh"){
        name = obj.jobtitle
    }

    return name
}

function loadAdvList(){
    const request = jobArrangementRecordApi.queryRecordListWithType
    const params = request.getParams()

    request.send(params, (res) => {
        if (res.code == 200){
            advTypeList.value = res.detail

            fillTypeOptions()
            getCustomerList()
        }else{
            myUtil.alertError(res.msg)
        }
    })

}

function fillTypeOptions(){
    const typeList = advTypeList.value
    let list = []

    typeList.forEach((v, i) => {
        // if (v.addinfo4 == 0){
        //     return
        // }

        if(null == v.updatedid || "" == v.updatedid){
            if(null == advTypeMap[v.id]){
                v.child = []
                advTypeMap[v.id] = v
            }else{
                let tempList = advTypeMap[v.id]
                advTypeMap[v.id] = v
                v.child = tempList
            }
        }else{
            if(null == advTypeMap[v.updatedid]){
                advTypeMap[v.updatedid] = [v]
            }else {
                if(advTypeMap[v.updatedid].length > 0){
                    advTypeMap[v.updatedid].push(v)
                }else if(null != advTypeMap[v.updatedid].child){
                    advTypeMap[v.updatedid].child.push(v)
                }
            }

            advTypeMap[v.id] = v
        }

        list = list.concat(v.list)
    })

    allAdvList = list
    advList.value = list

    //设置级联选项数据
    const mainList = [{
        typeCode: 0,
        typename: i18n.tkey("lang_all"),
        typename2: i18n.tkey("lang_all")
    }]

    const keys = Object.keys(advTypeMap)

    keys.forEach((key) => {
        const obj = advTypeMap[key]

        if (obj.id == -1){
            return
        }

        if (null != obj.child){
            const data = {
                typeCode: obj.id,
                typename: obj.addinfo1,
                typename2: obj.addinfo2,
                disabled: obj.addinfo3 == -1
            }

            if (obj.addinfo4 == 0){
                data.disabled = false
                data.addinfo4 = 0
            }

            mainList.push(data)
        }
    })

    mainTypeList.value = mainList
}

function selectOptionCallback(obj){
    currType.value = obj.typeCode

    if (myUtil.isEmpty(obj.parentCode)){
        parentType.value = null
    }else{
        parentType.value = obj.parentCode
    }

    if (obj.typeCode == 0){
        subTypeList.value = []
        parentType.value = null
        advList.value = allAdvList
        return
    }

    const mainTypeObj = advTypeMap[obj.typeCode]
    const subList = []
    let dataList = []

    if (null != mainTypeObj.list && mainTypeObj.list.length > 0){
        dataList = dataList.concat(mainTypeObj.list)
    }

    if (null != mainTypeObj.child){
        mainTypeObj.child.forEach((v) => {
            subList.push({
                typeCode: v.id,
                typename: v.addinfo1,
                typename2: v.addinfo2,
                parentCode: mainTypeObj.id,
                disabled: v.addinfo3 == -1
            })

            dataList = dataList.concat(v.list)
        })

        subTypeList.value = subList
    }

    if (obj.addinfo4 == 0){
        dataList = dataList.concat(customerRecordList.value)
    }

    advList.value = dataList
}

function getCustomerList(){
    const request = jobArrangementRecordApi.queryRecord
    const params = request.getParams()

    params.jatype = 2

    request.send(params, (res) => {
        if (res.code == 200){
            customerRecordList.value = res.detail
        }else{
            myUtil.alertError(res.msg)
        }
    })

}

onBeforeMount(() => {
    loadAdvList()
})

onMounted(() => {
    domWidth.value = proxy.$refs.advSearchDom.offsetWidth

    if (domWidth.value > 768){
        cols.value = 6
        advWidth.value = domWidth.value / 4 - 40
    }else{
        advWidth.value = domWidth.value / 2 - 40
    }

    advHeight.value = Math.floor(advWidth.value / 16 * 9)
})

</script>

<style scoped>

.adv-part-box {
    width: 100%;
    box-sizing: border-box;
    margin-top: 10px;
    padding-left: 10px;
    padding-right: 10px;

}

.adv-record-box {
    padding-top: 10px;
    padding-bottom: 10px;
    border: 1px #EBEEF5 solid;
    box-sizing: border-box;
    border-radius: 5px;
}

.title-box {
    color: #606266;
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 10px;
    text-align: center;
}

@media screen and (min-width: 768px) {
    .type-selector-box {
        width: calc(56% + 20px);
        margin: auto;
    }
}

@media screen and (max-width: 768px) {
    .type-selector-box {
        width: 100%;
        margin: auto;
    }
}

</style>